import { HTTP_GET, HTTP_POST } from './appConstants'
import { post, get } from '../../irmlib/src/http/basehttp'


/**
 * 
 * @param {string} method GET/POST http method types
 * @param {string} apiUrl  endpoint url
 * @param {object} requestBody request body content
 * @param {object} params path/query param details
 * @param {object} headers header info
 * @returns {object} wsg call response
 */
export const invokeWsgRequest = async (method, apiUrl, requestBody, params, headers) => {
  let response = null
  switch (method) {
    case HTTP_GET:
      response = await get(apiUrl, headers)
      break
    case HTTP_POST:   
      response = await post(apiUrl, requestBody, headers)
      break
    default:
      response = await get(apiUrl, requestBody, headers)
  } 
  return response  
}